import { render, staticRenderFns } from "./EnterTerminationDetails.vue?vue&type=template&id=01916963&scoped=true"
import script from "./EnterTerminationDetails.vue?vue&type=script&lang=js"
export * from "./EnterTerminationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01916963",
  null
  
)

export default component.exports